import { css } from '@emotion/css';

export const primaryMenuItemStyles = css`
  &:hover,
  &.Mui-focusVisible:hover,
  &.Mui-focusVisible {
    background-color: var(--bg-hover);
  }

  &:active,
  &.Mui-focusVisible:active {
    background-color: var(--interactive-secondary-hover);
  }

  &.Mui-disabled {
    .MenuItem-endIcon,
    .MenuItem-startIcon {
      fill: var(--border-dark);
    }

    .MenuItem-label {
      color: var(--border-dark);
    }
  }
`;

export const secondaryMenuItemStyles = css`
  &:hover,
  &.Mui-focusVisible:hover,
  &.Mui-focusVisible {
    background-color: var(--bg-tertiary);
  }

  &:active,
  &.Mui-focusVisible:active {
    background-color: var(--field);
  }

  &:active {
    .MenuItem-label {
      color: var(--text-primary);
    }

    .MenuItem-endIcon,
    .MenuItem-startIcon {
      fill: var(--icon-active);
    }
  }
`;

export const dangerMenuItemStyles = css`
  &:hover,
  &.Mui-focusVisible:hover,
  &.Mui-focusVisible {
    background-color: var(--bg-error-light);
  }

  &:active,
  &.Mui-focusVisible:active {
    background-color: var(--border-error);
  }

  &:active {
    .MenuItem-label {
      color: var(--text-error-dark);
    }

    .MenuItem-endIcon,
    .MenuItem-startIcon {
      fill: var(--bg-error);
    }
  }

  &.Mui-disabled {
    .MenuItem-endIcon,
    .MenuItem-startIcon {
      fill: var(--border-error-dark);
    }

    .MenuItem-label {
      color: var(--border-error-dark);
    }
  }
`;

export const linkMenuItemStyles = css`
  &:hover,
  &.Mui-focusVisible:hover,
  &.Mui-focusVisible {
    background-color: var(--bg-accent-light);
  }

  &:active,
  &.Mui-focusVisible:active {
    background-color: var(--border-accent);
  }

  &:active {
    .MenuItem-label {
      color: var(--text-accent-dark);
    }

    .MenuItem-endIcon,
    .MenuItem-startIcon {
      fill: var(--bg-accent);
    }
  }

  &.Mui-disabled {
    .MenuItem-endIcon,
    .MenuItem-startIcon {
      fill: var(--border-accent-dark);
    }

    .MenuItem-label {
      color: var(--border-accent-dark);
    }
  }
`;

export const menuItemStyles = css`
  .MenuItem-endIcon-root,
  .MenuItem-startIcon-root {
    display: inherit;
  }
`;
